export default __webpack_public_path__ + "static/media/baby-19.93be76e9.svg";